import styled from "styled-components";
import { Dropdown } from "react-bootstrap";
import { buttonStyleMixin } from "./Button";

export default styled(Dropdown.Toggle)`
	${buttonStyleMixin}
`;
